﻿import { on } from "../helpers/events/on.js";

(function (DealPage) {
    const ModalEvent = {
        HIDDEN: "hidden.generic.modal",
        SHOWN: "shown.generic.modal"
    }
    var openTab = function (tabHeadingId, tabName) {
        // Get all elements with class="tabcontent" and hide them
        var tabcontent = document.getElementsByClassName("modaltabcontent");
        for (var i = 0; i < tabcontent.length; i++) {
            var htmlElement = tabcontent[i];
            htmlElement.style.display = "none";
            htmlElement.scrollIntoView(true);
        }
        // Get all elements with class="tablinks" and remove the class "active"
        var tablinks = document.getElementsByClassName("modaltablinks");
        for (var i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(tabName).style.display = "block";
        document.getElementById(tabHeadingId).className += " active";
    };

    var togglePanel = function (modalId) {
        var x = document.querySelectorAll(`#${modalId} .vehicle-panel-wrap`);
        [].forEach.call(x, function (el) {
            if (el.style.display == "none") {
                window.$(el).fadeIn();
                document.querySelector(".modal-vehicle-details .modal-body").scrollTop = 0;
            }
            else {
                el.style.display = "none";
            }
        });
    };

    const initVehicleEquipmentModals = () => {
        document.querySelectorAll("#vehicle-equipment-modal-1,#vehicle-equipment-modal-2,#vehicle-equipment-modal-3").forEach(function (modalElement) {
            modalElement.addEventListener(ModalEvent.SHOWN, function (event) {
                const modalCounter = event.target.id.slice(-1);
                openTab("defaultTab-" + modalCounter, "Equipment-" + modalCounter);
            });
        });
    }

    const initVehicleDetailsModals = () => {
        document.querySelectorAll("#vehicle-details-modal-1,#vehicle-details-modal-2,#vehicle-details-modal-3").forEach(function (modalElement) {
            modalElement.addEventListener(ModalEvent.SHOWN, function (event) {
                const modalCounter = event.target.id.slice(-1);
                document.getElementById("keyinfo-" + modalCounter).style.display = "block";
                document.getElementById("fullinfo-" + modalCounter).style.display = "none";
                document.querySelector(`#${event.target.id} .modal-body`).scrollTop = 0;
            });
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        on("click", "#defaultTab-1,#defaultTab-2,#defaultTab-3", (event) => {
            const tabHeadingId = event.target.id;
            const tabName = event.target.dataset.tabName;
            openTab(tabHeadingId, tabName);
        });

        on("click", "#optionalExtrasTab-1,#optionalExtrasTab-2,#optionalExtrasTab-3", (event) => {
            const tabHeadingId = event.target.id;
            const tabName = event.target.dataset.tabName;
            openTab(tabHeadingId, tabName);
        });

        on("click", "#viewFullSpecification-1,#viewFullSpecification-2,#viewFullSpecification-3", (event) => {
            const modalId = event.target.dataset.modalId;
            togglePanel(modalId);
        });

        on("click", "#hideFullSpecification-1,#hideFullSpecification-2,#hideFullSpecification-3", (event) => {
            const modalId = event.target.dataset.modalId;
            togglePanel(modalId);
        });
    });

    var enquiryForm = (function () {
        var errorClass = 'invalid',
            validClass = "valid",
            inputFocusClass = "inputfocus",
            $emailField = $("#txtFrom"),
            $fullNameField = $("#txtName1"),
            $phoneField = $("#txtPhone"),
            $dayField = $("#selDay"),
            $timeField = $("#selTime"),
            $postcodeField = $("#txtPostcode"),
            $postcodeField2 = $("#txtPostcode2"),
            emailFieldId = "txtFrom",
            $overrideEmailField = $("#overrideEmail"),
            $overrideEmailContainer = $("#overrideEmailContainer"),
            overrideEmailFieldId = "overrideEmail",
            $form = $("#EnquiryForm"),
            $submitButtons = $(document).find(".submitEnquiryCTA "),
            fullNameFieldId = "txtName1",
            phoneFieldId = "txtPhone",
            isEmailValid = false,
            isEmailVerified = false,
            isPhoneValid = false,
            isDayValid = false,
            isTimeValid = false,
            isPostcodeValid = true,
            queryClass = "query",
            isFullNameValid = false;

        let marketingOptIn = {
            lastRetrievedEmailAddress: ""
        }

        $submitButtons.prop("disabled", true);
        $(document).find("button.submitEnquiryCTA").prop("disabled", true);

        $overrideEmailContainer.hide();

        var Highlight = function (element, errorClass, validClass) {
            $(element).parent().addClass("qtooltip");
            $(element).parent().addClass(errorClass).removeClass(validClass);
        };

        var UnHighlight = function (element, errorClass, validClass) {
            $(element).parent().removeClass("qtooltip");
            $(element).parent().removeClass(errorClass).addClass(validClass);

        };

        const RefreshOptInStatus = () => {
            const emailAddress = $emailField.val();

            // don't continue if the email address is invalid or if we've retrieved the opt-in status for this email already
            if (!isEmailValid || marketingOptIn.lastRetrievedEmailAddress === emailAddress) {
                return;
            }

            $.get(`/account/marketing-optin-status?emailAddress=${emailAddress}`)
                .then(function (optInStatus) {
                    // update the opt-in checkbox
                    document.getElementById("MarketingOptedin").checked = optInStatus !== "OptOut";

                    // update the last retrieved email address
                    marketingOptIn.lastRetrievedEmailAddress = emailAddress;
                });
        }

        var InvokeNeverBounce = function () {
            if (!isEmailValid) {
                return;
            }

            $submitButtons.prop("disabled", true);

            $emailField.parent().addClass(queryClass).removeClass(validClass).removeClass(errorClass);

            $.ajax({
                url: "/service/validate-email-address",
                headers: {
                    "Content-Type": "application/json"
                },
                dataType: "JSON",
                method: "POST",
                data: JSON.stringify({
                    emailAddress: $emailField.val()
                })
            }).done(function (response) {
                const verified = response.isValid;
                if (!verified && !$overrideEmailField.is(":checked")) {
                    $overrideEmailContainer.show();
                    isEmailVerified = false;
                    Highlight($emailField, errorClass, validClass);
                }
                else if (verified && $overrideEmailField.is(":checked")) {
                    UnHighlight($emailField, errorClass, validClass);
                    isEmailVerified = true;
                }
                else if (!verified && $overrideEmailField.is(":checked")) {
                    isEmailVerified = true;
                    UnHighlight($emailField, errorClass, validClass);
                }
                else if (verified && !$overrideEmailField.is(":checked")) {
                    UnHighlight($emailField, errorClass, validClass);
                    isEmailVerified = true;
                    $overrideEmailContainer.hide();
                }
            })
                .fail(function () {
                    $overrideEmailContainer.hide();
                    UnHighlight($emailField, errorClass, validClass);
                    isEmailVerified = true;
                })
                .always(function () {
                    SetButtonState();
                    $emailField.parent().removeClass(queryClass);

                });
        };

        var SetButtonState = function () {
            if (isEmailValid && isEmailVerified && isPhoneValid && isFullNameValid && isDayValid && isTimeValid && isPostcodeValid) {
                $submitButtons.prop("disabled", false);
                $(document).find("button.submitEnquiryCTA").prop("disabled", false);
            } else {
                $submitButtons.prop("disabled", true);
                $(document).find("button.submitEnquiryCTA").prop("disabled", true);
            }
        };

        var ValidatePhone = function () {
            var element = $phoneField[0];

            var regex = /^[0-9(\s)]*$/;

            if (element.value.length >= 9 && regex.test(element.value)) {
                UnHighlight(element, errorClass, validClass);
                isPhoneValid = true;
            } else {
                Highlight(element, errorClass, validClass);
                isPhoneValid = false;
            }

            SetButtonState();
        };

        var ValidateName = function () {
            var element = $fullNameField[0];

            if (element.value.length > 0) {
                UnHighlight(element, errorClass, validClass);
                isFullNameValid = true;
            } else {
                Highlight(element, errorClass, validClass);
                isFullNameValid = false;
            }

            SetButtonState();
        };

        var ValidateEmail = function () {
            var regex =
                /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

            isEmailValid = regex.test($emailField.val());

            if (isEmailValid && isEmailVerified) {
                UnHighlight($emailField, errorClass, validClass);
            } else {
                Highlight($emailField, errorClass, validClass);
            }

            SetButtonState();
        };

        var ValidateDay = function () {
            var element = $dayField[0]

            if (element.value || !DealPage.isCallbackEnquiry()) {
                UnHighlight(element, errorClass, validClass);
                isDayValid = true;
            } else {
                Highlight(element, errorClass, validClass);
                isDayValid = false;
            }

            SetButtonState();
        };

        var ValidateTime = function () {
            var element = $timeField[0]

            if (element.value || !DealPage.isCallbackEnquiry()) {
                UnHighlight(element, errorClass, validClass);
                isTimeValid = true;
            } else {
                Highlight(element, errorClass, validClass);
                isTimeValid = false;
            }

            SetButtonState();
        };

        var ValidatePostcode = function () {
            var pattern = /^(?:[A-PR-UWYZ][0-9][0-9]?|[A-PR-UWYZ][A-HK-Y][0-9][0-9]?|[A-PR-UWYZ][0-9][A-HJKSTUW]|[A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY])\s?[0-9][ABD-HJLNP-UW-Z]{2}$/i;

            // Check both postcode fields but track them separately
            var hasValidPostcode1 = false;
            var hasValidPostcode2 = false;

            // Validate original postcode field (for Lotus, Polestar)
            if ($postcodeField.is(":visible")) {
                if (pattern.test($postcodeField.val().trim())) {
                    UnHighlight($postcodeField[0], errorClass, validClass);
                    hasValidPostcode1 = true;
                } else {
                    Highlight($postcodeField[0], errorClass, validClass);
                    hasValidPostcode1 = false;
                }
            }

            // Validate alternative postcode field (for A/B test)
            if ($postcodeField2.is(":visible")) {
                if (pattern.test($postcodeField2.val().trim())) {
                    UnHighlight($postcodeField2[0], errorClass, validClass);
                    hasValidPostcode2 = true;
                } else {
                    Highlight($postcodeField2[0], errorClass, validClass);
                    hasValidPostcode2 = false;
                }
            }

            // Postcode is valid if:
            // - Original field is visible AND valid, OR
            // - Alternative field is visible AND valid, OR  
            // - Neither field is visible (no postcode required)
            isPostcodeValid =
                ($postcodeField.is(":visible") && hasValidPostcode1) ||
                ($postcodeField2.is(":visible") && hasValidPostcode2) ||
                (!$postcodeField.is(":visible") && !$postcodeField2.is(":visible"));

            SetButtonState();
        };

        var SetupValidation = function () {
            $overrideEmailField.on('change', function () {
                $emailField.parent().removeClass(validClass).removeClass(errorClass).removeClass(queryClass);

                if ($overrideEmailField.is(":checked")) {
                    isEmailVerified = true;
                } else {
                    isEmailVerified = false;
                }

                if (isEmailVerified && isEmailValid) {
                    UnHighlight($emailField, errorClass, validClass);
                } else {
                    Highlight($emailField, errorClass, validClass);
                }

                SetButtonState();
            });

            $phoneField.on("input change", function () {
                ValidatePhone();
            });

            $emailField.on("input change", function () {
                ValidateEmail();
            });

            $fullNameField.on("input change", function () {
                ValidateName();
            });

            $dayField.on("input change", function () {
                ValidateDay();
            });

            $timeField.on("input change", function () {
                ValidateTime();
            });

            $postcodeField.on("input change", function () {
                ValidatePostcode();
            });

            $postcodeField2.on("input change", function () {
                ValidatePostcode();
            });

            $emailField.on('focusout', function () {
                RefreshOptInStatus();
                InvokeNeverBounce();
            });

            $(function () {
                if ($fullNameField.val().length > 0) {
                    ValidateName();
                }
                if ($emailField.val().length > 0) {
                    isEmailValid = true;
                    isEmailVerified = true;
                    SetButtonState();
                }
                if ($phoneField.val().length > 0) {
                    ValidatePhone();
                }
                if (!DealPage.isCallbackEnquiry()) {
                    isTimeValid = true;
                    isDayValid = true;
                }

                if ($dayField.val()) {
                    ValidateDay();
                }
                if ($timeField.val()) {
                    ValidateTime();
                }

                // Initialize postcode validation state
                if ($postcodeField.is(":visible") || $postcodeField2.is(":visible")) {
                    isPostcodeValid = false; // Start invalid when either field is visible
                } else {
                    isPostcodeValid = true; // Valid when no postcode fields are visible
                }

                // Validate if fields already have values
                if ($postcodeField.val() || $postcodeField2.val()) {
                    ValidatePostcode();
                }

                SetButtonState();
            });

            $form.on('submit', function (e) {
                e.preventDefault();

                $submitButtons.prop("disabled", true);
                $(document).find("button.submitEnquiryCTA").prop("disabled", true);

                var formObject = {};

                // Extract the postcode value
                var postcodeValue = $postcodeField.val();

                if ($emailField.prop("disabled")) {
                    $emailField.prop("disabled", false);

                    $.map($form.serializeArray(),
                        function (n, i) {
                            formObject[n['name']] = n['value'];
                        });

                    $emailField.prop("disabled", true);
                } else {
                    $.map($form.serializeArray(),
                        function (n, i) {
                            formObject[n['name']] = n['value'];
                        });
                }

                // Prepend the postcode value to the message
                if (postcodeValue) {
                    formObject.Message = `Postcode: ${postcodeValue}\n\n${formObject.Message}`;
                }

                var formData = {
                    customerEmail: formObject.CustomerEmail,
                    customerName: formObject.CustomerName,
                    customerPhone: formObject.CustomerPhone,
                    customerCompany: formObject.CustomerCompany,
                    message: formObject.Message,
                    sessionReference: formObject.SessionReference,
                    testEnquiry: formObject.TestEnquiry,
                    companyName: formObject.companyName,
                    dealIdentifier: formObject.dealIdentifier,
                    dealLink: formObject.dealLink,
                    financeSubType: formObject.financeSubType,
                    financeType: formObject.financeType,
                    inStock: formObject.inStock,
                    manufacturer: formObject.manufacturer,
                    profileGuid: formObject.profileGuid,
                    range: formObject.range,
                    vehicleId: formObject.vehicleId,
                    vehicleType: formObject.vehicleType,
                    // paint: DealPage.getSelectedColour(),
                    // options: DealPage.getSelectedOptions(),
                    paint: null,
                    options: null,
                    marketingOptedin: formObject.MarketingOptedin === 'on',
                    requestId: formObject.requestId,
                    isOneClickEnquiry: formObject.isOneClickEnquiry,
                    numberOfVehicles: formObject.NumberOfVehicles
                };

                if (DealPage.isCallbackEnquiry()) {
                    formData.message = `Please call me back ${$dayField.val()} ${$timeField.val()}. ` + formObject.Message;
                }

                $.ajax({
                    url: '/service/SubmitDealEnquiry',
                    method: 'POST',
                    headers: {
                        "x-csrf-token": $('[name=__RequestVerificationToken]', '#AjaxAntiForgery')
                            .val()
                    },
                    data: formData,

                    success: function (data) {
                        EnquiryReturn(data, $form, formData);
                    },
                    error: function (err, status, thrown) {
                        var ajaxErrorMessage = 'Error: SubmitDealEnquiry - ' +
                            (err.responseText || status || thrown || 'Unspecified error');

                        rgdCommonLogHelper.NLogErrorAsync(ajaxErrorMessage);

                        if (ajaxErrorMessage.includes("DNA")) {
                            alert("Sorry, this deal is no longer available.");
                        } else if (ajaxErrorMessage.includes("CNP")) {
                            alert("There was a problem submitting your Enquiry - Please try again.");
                        } else if (ajaxErrorMessage.includes("InvalidEmail")) {
                            $("#txtFrom").parent().addClass("invalid").removeClass("valid");
                        } else {
                            alert("An error has occurred. Please try again.");
                        }
                    },
                    complete: function () {
                        $submitButtons.prop("disabled", false);
                        $(document).find("button.submitEnquiryCTA").prop("disabled", false);
                    }
                });
            });
        };

        var EnquiryReturn = function (data, form, formObject) {
            $('#EnquiryForm').data("enquiry-completed", true);  // This gets used after the send-to-friend form

            $.ajax({
                url: '/service/RegisteredUserCheck',
                method: 'POST',
                data: {
                    email: $('#txtFrom').val()
                },
                success: function (data) {
                    // Registered Users
                    if (data.Registered === true) {
                        DealPage.enquirerHasVisitorAccount(true);
                        /*  $("#MyAccount").show();*/
                        /* $("#MyAccountFooter").show();*/
                        /*$("#VisitMyAccountArea").show();*/
                    } else {
                        // Not a registered user
                        DealPage.enquirerHasVisitorAccount(false);
                        /*$("#VisitMyAccountArea").hide();*/
                    }
                    // get recommended deals via endpoint using POST
                    $.ajax({
                        url: '/service/GetRecommendedDeals',
                        method: 'GET',
                        headers: {
                            "x-csrf-token": $('[name=__RequestVerificationToken]', '#AjaxAntiForgery')
                                .val()
                        },
                        data: {
                            advertiserName: formObject.companyName,
                            dealIdentifier: formObject.dealIdentifier,
                            customerName: formObject.customerName,
                            customerCompany: formObject.customerCompany,
                            customerEmail: formObject.customerEmail,
                            customerPhone: formObject.customerPhone,
                            sessionReference: formObject.sessionReference,
                        },
                        success: function (deals) {
                            // load returned deals into page
                            $("#alternative-deals").html(deals);
                            initVehicleEquipmentModals();
                            initVehicleDetailsModals();
                            $("#OneClickEnquiryForm-1, #OneClickEnquiryForm-2, #OneClickEnquiryForm-3").on("submit", function (e) {
                                e.preventDefault();

                                var formObject = {};
                                var alternativeEnquiryForm = $(this);

                                $.map(alternativeEnquiryForm.serializeArray(),
                                    function (n, i) {
                                        formObject[n['name']] = n['value'];
                                    });

                                var formData = {
                                    customerEmail: formObject.CustomerEmail,
                                    customerName: formObject.CustomerName,
                                    customerPhone: formObject.CustomerPhone,
                                    customerCompany: formObject.CustomerCompany,
                                    message: formObject.Message,
                                    sessionReference: formObject.SessionReference,
                                    companyName: formObject.companyName,
                                    dealIdentifier: formObject.dealIdentifier,
                                    dealLink: formObject.dealLink,
                                    financeSubType: formObject.financeSubType,
                                    financeType: formObject.financeType,
                                    inStock: formObject.inStock,
                                    manufacturer: formObject.manufacturer,
                                    profileGuid: formObject.profileGuid,
                                    range: formObject.range,
                                    vehicleType: formObject.vehicleType,
                                    paint: null,
                                    options: null,
                                    marketingOptedin: $("#MarketingOptedin").val() == "on",
                                    requestId: formObject.requestId,
                                    isOneClickEnquiry: formObject.isOneClickEnquiry
                                };

                                $.ajax({
                                    url: '/service/SubmitDealEnquiry',
                                    method: 'POST',
                                    headers: {
                                        "x-csrf-token": $('[name=__RequestVerificationToken]', '#AjaxAntiForgery')
                                            .val()
                                    },
                                    data: formData,
                                    success: function (data) {
                                        alternativeEnquiryForm.slideUp();
                                        $("#oneClickEnquirySuccessMessage-" + alternativeEnquiryForm[0].id.slice(-1)).slideDown();
                                    },
                                    error: function (err, status, thrown) {
                                        var ajaxErrorMessage = 'Error: SubmitAlternativeDealEnquiry - ' +
                                            (err.responseText || status || thrown || 'Unspecified error');

                                        rgdCommonLogHelper.NLogErrorAsync(ajaxErrorMessage);
                                    },
                                    complete: function () {

                                    }
                                });
                            });
                        },
                        error: function (err, status, thrown) {

                        },
                        complete: function () {

                        }
                    });


                },
                error: function (err, status, thrown) {
                    console.log(err);
                }
            });

            DealPage.enquiryCompleted();

        };

        var setupEnquiryForm = function () {
            SetupValidation();
            $dayField.val("");
            $timeField.val("");
            isDayValid = !DealPage.isCallbackEnquiry();
            isTimeValid = !DealPage.isCallbackEnquiry();
        };

        // Hide bottom Deal panel when form fields are active
        var formInputSelector = '#EnquiryForm input[type=text], input[type=tel], input[type=email], textarea';
        $(formInputSelector).on('focus', function () {
            $('body').addClass(inputFocusClass);
        });
        $(formInputSelector).on('blur', function () {
            $('body').removeClass(inputFocusClass);
        });

        return {
            setupEnquiryForm: setupEnquiryForm
        };

    })();

    DealPage.EnquiryForm = enquiryForm;

})(DealPage || (DealPage = {}));
